import React from "react";
import ScrollReveal from "./ScrollReveal";
import { GALLERY } from "../lib/siteData";

export const Gallery = () => {
  return (
    <section
      data-testid="gallery-section"
      className="bg-[#F5F5F0] py-24 md:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid md:grid-cols-12 gap-10 mb-16">
          <div className="md:col-span-5">
            <div className="flex items-center gap-4 mb-6">
              <span className="hairline-gold" />
              <span className="overline">Cape Maclear · Lake Malawi</span>
            </div>
            <h2 className="font-serif-display text-4xl md:text-5xl leading-tight text-[#1A1D20]">
              A landscape worth<br />a landmark project.
            </h2>
          </div>
          <div className="md:col-span-6 md:col-start-7 flex items-end">
            <p className="text-[#5C636A] text-[15px] md:text-[17px] leading-relaxed">
              Cape Maclear — known locally as Chembe — sits on a golden-sand
              peninsula of Lake Malawi, a UNESCO World Heritage freshwater
              paradise with more endemic fish species than any lake on earth.
              This is the setting we are building with.
            </p>
          </div>
        </div>

        {/* Asymmetric bento grid */}
        <div className="grid grid-cols-12 gap-4 md:gap-6 auto-rows-[140px] md:auto-rows-[180px]">
          {GALLERY.map((img, i) => {
            const spans = [
              "col-span-12 md:col-span-7 row-span-2",
              "col-span-6 md:col-span-5 row-span-1",
              "col-span-6 md:col-span-5 row-span-1",
              "col-span-12 md:col-span-4 row-span-2",
              "col-span-6 md:col-span-4 row-span-1",
              "col-span-6 md:col-span-4 row-span-1",
            ];
            return (
              <ScrollReveal
                key={img.url}
                delay={i * 0.05}
                className={`${spans[i % spans.length]} relative overflow-hidden group`}
              >
                <img
                  src={img.url}
                  alt={img.caption}
                  loading="lazy"
                  data-testid={`gallery-img-${i}`}
                  className="absolute inset-0 w-full h-full object-cover group-hover:scale-[1.06] transition-transform duration-[1200ms] ease-out"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#1A1D20]/70 via-transparent to-transparent opacity-80 group-hover:opacity-100 transition-opacity" />
                <div className="absolute bottom-4 left-4 right-4 text-[#FCFCFA]">
                  <span className="text-[11px] uppercase tracking-[0.22em] text-[#D4AF37]">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <p className="font-serif-display text-lg md:text-2xl leading-tight mt-1">
                    {img.caption}
                  </p>
                </div>
              </ScrollReveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Gallery;
